<template>
  <div v-if="shopId" id="shippingProvider">
    <SfHeading v-e2e="'shipping-heading'" :level="3" :title="$t('Shipping_method')"
      class="sf-heading--left sf-heading--no-underline title" />
    <SfRadio v-e2e="'shipping-method'" v-for="method in shippingMethods" :key="method.carryId" :value="method.carryId"
      :description="method.expressName + ' ' + method.postage" v-model="selectedMethodId" name="shippingMethod"
      class="form__radio shipping" @change="selectMethod(method)">
      <template #label>
        <div>
          <span
            v-if="expressCurrent && method.carryId == expressCurrent.carryId && method.postage > expressCurrent.postage">{{
              method.expressName }} {{ $n(expressCurrent.postage, 'currency') }} <span
              style="text-decoration:line-through;float: right;">{{ $t("discount_post_fee") }} {{ $n(method.postage,
                'currency') }}</span></span>
          <span v-else>
            {{ method.expressName + ' ' + $n(method.postage, 'currency') }}
          </span>
        </div>
      </template>
      <div class="shipping__description" slot="description">
        <div>{{ method.desc }}</div>
      </div>
    </SfRadio>
    <SfButton v-if="false" v-e2e="'continue-to-billing'" :disabled="!selectedMethodId" type="button"
      @click="$emit('submit')" class="margintop">
      {{ $t('Continue_billing') }}
    </SfButton>
  </div>
</template>

<script>
import { SfButton, SfRadio, SfHeading } from '@storefront-ui/vue';
import { ref, computed, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { usePreviewOrderStore } from '~/stores/previewOrder';

// const SHIPPING_METHODS = [
//   { label: 'Express US', value: 'express', description: 'Same day delivery' },
//   { label: 'Standard US', value: 'standard', description: 'Delivery in 5-6 working days' }
// ];
import { EventBus } from '@/plugins/eventBus';
import { usePreviewOrder } from '@bee-hole/coms';
export default {
  name: 'VsfShippingProvider',
  props: {
    addressId: {
      default: 0
    },
    shopId: {
      type: Number,
      default: -1
    }
  },
  components: {
    SfButton,
    SfRadio,
    SfHeading
  },

  setup(props, { emit }) {
    const shopId = computed(() => props.shopId);
    const previewOrderStore = usePreviewOrderStore();
    const express = previewOrderStore.shippingMethods?.filter((item) => String(item.shop_id) === String(shopId.value));
    const selectedMethodId = ref(String(express?.[0]?.carry_id || ''));
    const { preorder } = usePreviewOrder();
    const expressCurrent = computed(() => {
      const order = preorder?.value?.orders?.find((order) => order?.shopId === shopId.value);
      return order?.express;
    });
    // const shippingMethods = computed(() => {
    //   return state?.value?.list;
    // });
    // console.log('previewOrderStore.shippingMethods', previewOrderStore.shippingMethods, express, selectedMethodId);
    const shippingMethods = computed(() => {
      // console.log('preorder?.value?.expressChart', preorder?.value?.expressChart, shopId.value);
      return preorder?.value?.expressChart?.[shopId.value] || [];
    });

    // console.log('context', context);
    const selectMethod = (method) => {
      // console.log('{ express_name: method.expressName, shop_id: shopId.value }', { express_name: method.expressName, shop_id: shopId.value })
      previewOrderStore.setShippingMethod({ carry_id: method.carryId, shop_id: shopId.value });
      // console.log('slect', method);
      // selectedMethodId.value = String(method.shipId);
      selectedMethodId.value = method.carryId;
      emit('change');
      EventBus.$emit('PreviewOrder', previewOrderStore.shippingMethods);
    };

    const setAddrssId = (addressId) => {
      if (addressId) {
        // console.log('preorder', preorder, shippingMethods.value);
      } else {
        // previewOrderStore.setShippingMethod(null);
      }
    };

    // 监控传入的addressId，如果改变了，重新加载配送方式

    // 初始化加载配送方式
    // console.log('查询发货方式', props.addressId);
    setAddrssId(props.addressId);
    onMounted(() => {
      EventBus.$on('changeExpress', (data) => {
        const paramsExpress = shippingMethods.value?.filter((item) => String(item.carryId) === String(data.carryId));
        if (paramsExpress && paramsExpress?.length === 1) {
          selectMethod(data);
        }
      });
    });
    onUnmounted(() => {
      EventBus.$off('changeExpress');
    });
    return {
      shippingMethods,
      selectedMethodId,
      selectMethod,
      expressCurrent
    };
  }
};
</script>

<style lang="scss" scoped>
.shipping {
  &__label {
    display: flex;
    justify-content: space-between;
  }

  &__description {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
  }

  &__price {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
    color: red;
  }
  margin-bottom: 0.25rem;
}

.margintop {
  margin-top: 20px;
}
</style>
<style lang="scss">
#shippingProvider{
  .sf-radio__container{
    padding: 0.5rem !important;
  }
}
</style>